/* Shared Journal interactions, ported from the approved local overview/reveal scripts. */
(() => {
  if (window.ukenaJournalOverviewMounted) return;
  window.ukenaJournalOverviewMounted = true;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const mobile = matchMedia('(max-width: 700px)');
  const running = new Set();
  let enabled = true;
  const stop = () => { running.forEach(a => a.cancel()); running.clear(); };
  const labels = () => document.querySelectorAll('.ukena-journal-motion-toggle').forEach(b => {
    b.hidden = false; b.disabled = reduce.matches;
    b.setAttribute('aria-pressed', String(enabled && !reduce.matches));
    b.textContent = reduce.matches ? 'Image motion: reduced' : `Image motion: ${enabled ? 'on' : 'off'}`;
  });
  const reveal = el => {
    const rect = el.getBoundingClientRect();
    if (!enabled || reduce.matches || document.hidden || !el.isConnected || rect.top >= innerHeight || rect.bottom <= 0 || el.contains(document.activeElement)) return;
    const kind = el.dataset.journalReveal;
    const x = mobile.matches ? 14 : 36;
    const offset = kind === 'left' ? [-x,8] : kind === 'right' ? [x,8] : [0,mobile.matches ? 18 : 28];
    const a = el.animate([{opacity:.35,transform:`translate(${offset[0]}px,${offset[1]}px)`},{opacity:1,transform:'translate(0,0)'}],{duration:kind === 'up' ? 800 : 720,easing:'cubic-bezier(.22,1,.36,1)'});
    running.add(a); a.finished.catch(()=>{}).finally(()=>running.delete(a));
  };
  const observer = 'IntersectionObserver' in window && Element.prototype.animate ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      const img = entry.target.querySelector('img');
      if (img && !img.complete) img.addEventListener('load',()=>reveal(entry.target),{once:true});
      else if (!img || img.naturalWidth) reveal(entry.target);
    });
  },{threshold:0,rootMargin:'0px 0px -32px 0px'}) : null;
  const init = () => {
    document.querySelectorAll('[data-ukena-photo-pair]:not([data-pair-ready])').forEach(pair => {
      const images = pair.querySelectorAll('img');
      const first = images[0], second = pair.querySelector('.ukena-photo-second'), button = pair.querySelector('.ukena-photo-switch');
      if (!first || !second || !button) return;
      pair.dataset.pairReady = '';
      let selected = false, hovering = false;
      const draw = () => {
        const visible = selected || hovering;
        pair.toggleAttribute('data-second-visible',visible);
        first.setAttribute('aria-hidden',String(visible)); second.setAttribute('aria-hidden',String(!visible));
        button.setAttribute('aria-label',`Show ${visible ? 'first' : 'second'} photograph for ${button.dataset.title}`);
        button.querySelector('span').textContent = visible ? 'Photo 2 of 2' : 'Photo 1 of 2';
      };
      const ready = () => {if (second.naturalWidth) {button.hidden=false;pair.dataset.imageReady='';}};
      second.addEventListener('load',ready);ready();
      const surface=pair.querySelector('a,.ukena-photo-surface');
      surface.addEventListener('pointerenter',()=>{if(fine.matches && pair.hasAttribute('data-image-ready')){hovering=true;draw();}});
      surface.addEventListener('pointerleave',()=>{hovering=false;draw();});
      button.addEventListener('click',()=>{selected=!(selected||hovering);hovering=false;draw();});
      draw();
    });
    document.querySelectorAll('[data-journal-reveal]:not([data-reveal-ready])').forEach(el => {
      el.dataset.revealReady='';
      if(observer && el.getBoundingClientRect().top>=innerHeight) observer.observe(el);
    });
    document.querySelectorAll('.ukena-journal-motion-toggle:not([data-motion-ready])').forEach(b=>{
      b.dataset.motionReady='';b.addEventListener('click',()=>{enabled=!enabled;if(!enabled)stop();labels();});
    });
    labels();
  };
  init();
  document.addEventListener('click',event => {
    const link = event.target.closest('[data-note-link]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
    const id = link.getAttribute('href');
    if (!id || !id.startsWith('#')) return;
    const note = document.getElementById(id.slice(1));
    if (note?.tagName !== 'DETAILS') return;
    note.open = true;
    note.querySelector('summary')?.focus({preventScroll:true});
    // Keep native anchor navigation and its shareable fragment; photo buttons are siblings.
  });
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',stop);
  document.addEventListener('visibilitychange',()=>{if(document.hidden)stop();});
  document.addEventListener('focusin',stop);
  window.addEventListener('beforeprint',stop);
  reduce.addEventListener('change',()=>{if(reduce.matches)stop();labels();});
})();
